import { makeStyles } from "$components/mui-styles";
import React from "react";

const useSuggestionWrapperStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      display: "inline",
      "&:not(:last-child)": {
        marginRight: theme.spacing(0.5),
      },
    },
    "& mark": {
      backgroundColor: "transparent",
      fontWeight: 600,
    },
  },
}));

export const SuggestionWrapper = (props: React.ComponentProps<"div">) => {
  const classes = useSuggestionWrapperStyles();
  return <div className={classes.root} {...props} />;
};
